import { render, staticRenderFns } from "./ExpressionTask.vue?vue&type=template&id=4c956883&scoped=true&"
import script from "./ExpressionTask.vue?vue&type=script&lang=js&"
export * from "./ExpressionTask.vue?vue&type=script&lang=js&"
import style0 from "./ExpressionTask.vue?vue&type=style&index=0&id=4c956883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c956883",
  null
  
)

export default component.exports